import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_data_table, {
      items: _ctx.chats,
      "item-value": "groupChatId",
      headers: _ctx.headers,
      "hide-default-footer": "",
      "no-data-text": _ctx.$t('mailbox.noData'),
      loading: _ctx.loading,
      color: "primary"
    }, {
      "item.date": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(item.date)), 1)
      ]),
      "item.chatReadCount": _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(item.chatReadCount), 1)
      ]),
      "item.edit": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickItem(item)),
          color: "primary",
          variant: "flat",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('mailbox.detail')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      "item.delete": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          onClick: ($event: any) => (_ctx.clickDelete(item)),
          color: "error",
          variant: "outlined",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('mailbox.delete')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["items", "headers", "no-data-text", "loading"])
  ]))
}